import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DebugPriceCalcComponent } from './debug-pricecalc.component';

const routes: Routes = [
  {
    path: '',
    component: DebugPriceCalcComponent,
    data: { title: 'Price Calculation Debug Screen' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DebugPriceCalcRoutingModule {}

@NgModule({
  imports: [
    DebugPriceCalcRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [DebugPriceCalcComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DebugPriceCalcModule {}
